module.exports = __webpack_public_path__ + "static/media/abouts-enabled.36523c9b.svg";